import { render, staticRenderFns } from "./Motoristas.vue?vue&type=template&id=77895fa4"
import script from "./Motoristas.vue?vue&type=script&lang=js"
export * from "./Motoristas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports